import AnimatedLoader from '@ilg-totallymoney/ui/components/AnimatedLoader'
import Box from '@ilg-totallymoney/ui/components/Box'

interface AnimatedLoadingPageProps {
    fill?: boolean
    heading?: string
    supportingText?: string | string[]
}

const AnimatedLoadingPage = ({
    heading = 'Checking your card offers',
    supportingText = 'See what you could get today',
    fill = true,
}: AnimatedLoadingPageProps) => {
    return (
        <Box zIndex={2} position="relative">
            {fill ? <Box height="100vh" /> : null}
            <Box position="absolute" top={0} left={0}>
                <AnimatedLoader
                    heading={heading}
                    supportingText={supportingText}
                />
            </Box>
        </Box>
    )
}

export default AnimatedLoadingPage
